// Libraries
import { FC } from "react";

// Types
import { ModalFooterProps } from "./ModalFooter.types";
import { cn } from "utils/cn";

export const ModalFooter: FC<ModalFooterProps> = ({ children, className, layout = "default" }) => {
  const isPanel = layout === "panel";

  return (
    <div
      className={cn(
        "flex flex-row flex-wrap items-center justify-end gap-2 text-regular-3 text-muted-foreground",
        isPanel && "border-t border-border px-4 py-4",
        className
      )}
      data-testid="modal-footer"
    >
      {children}
    </div>
  );
};

export default ModalFooter;
